import { useState, useEffect } from "react";
import { Modal, Table, Radio, Button } from "antd";
import {
  RepresentationDocumentNumberCell,
  components,
} from "@entities/journal";
import { formatDate, fallbackString } from "@shared/utils";


type Examination = components["schemas"]["DocumentationExamination"];

type Props = {
  open: boolean;
  onClose: () => void;
  onSelect: (selected: Examination) => void;
  examination: Examination[];
  title?: string;
};

export const RepresentationDocumentationExaminationModal = ({
  open,
  onClose,
  onSelect,
  examination,
  title = "Выберите разрешение на строительство",
}: Props) => {
  const [selectedId, setSelectedId] = useState<string | null>(null);

  useEffect(() => {
    const defaultSelected = examination.find(
      (p) => p.selectedDocumentExamination,
    );
    setSelectedId(defaultSelected?.documentationExaminationId ?? null);
  }, [examination]);

  const handleSelect = () => {
    const selected = examination.find(
      (p) => p.documentationExaminationId === selectedId,
    );
    if (selected) onSelect(selected);
  };

  const columns = [
    {
      title: "",
      dataIndex: "documentationExaminationId",
      render: (id: string) => (
        <Radio checked={selectedId === id} onChange={() => setSelectedId(id)} />
      ),
      width: 50,
    },
    {
      title: "№ заключения",
      dataIndex: "number",
      render: (number: string, record: Examination) => (
        <RepresentationDocumentNumberCell
          number={number}
          attachment={record.examinationFile}
        />
      ),
    },
    {
      title: "Дата выдачи",
      dataIndex: "date",
      render: (date?: string) => fallbackString(formatDate(date)),
    },
    {
      title: "Наименование органа, выдавшего разрешение",
      dataIndex: "issued",
    },
    {
      title: "Срок действия",
      dataIndex: "expiryDate",
      render: (expiryDate?: string) => fallbackString(formatDate(expiryDate)),
    },
    {
      title: "Продлено до",
      dataIndex: "prolongDate",
      render: (date?: string) => fallbackString(formatDate(date)),
    },
  ];

  return (
    <Modal
      open={open}
      title={title}
      onCancel={onClose}
      zIndex={1000}
      className="representation-documentation-modal"
      footer={[
        <Button
          key="confirm"
          type="primary"
          onClick={handleSelect}
          disabled={!selectedId}
        >
          Подтвердить выбор
        </Button>,
      ]}
      width={800}
    >
      <Table
        dataSource={examination}
        columns={columns}
        pagination={false}
        rowKey="documentationExaminationId"
      />
    </Modal>
  );
};
